import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=f60eeff8&scoped=true&"
import script from "./ContentItem.vue?vue&type=script&lang=js&"
export * from "./ContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=f60eeff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60eeff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60eeff8')) {
      api.createRecord('f60eeff8', component.options)
    } else {
      api.reload('f60eeff8', component.options)
    }
    module.hot.accept("./ContentItem.vue?vue&type=template&id=f60eeff8&scoped=true&", function () {
      api.rerender('f60eeff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ContentItem.vue"
export default component.exports